




















import theme from '@zk/theme/lib/variables.scss';
import { defineComponent, toRef } from '@vue/composition-api';

import { useFieldLayout } from '../store';
// import { useInstance } from 'common-module/src/util/useInstance';

export default defineComponent({
  name: 'LayoutDrawerFooter',
  props: {},
  setup() {
    const store = useFieldLayout();

    return {
      saveLoading: toRef(store, 'saveLoading'),
      onCancel: toRef(store, 'closeDrawer')
    };
  },
  data() {
    return {
      bemNS: theme.bemNS
    };
  }
});
